export default "__VITE_ASSET__BG4TNE$G__"